import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Salesperformance.css';
import FormAside from "./FormAside"
import { FaCheckCircle, FaEnvelope, FaWhatsapp } from 'react-icons/fa';  // Importing the Font Awesome check-circle and envelope icons
import FormNotification from './FormNotification';
import { FaFontAwesome } from 'react-icons/fa';
function SalesPerformance() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    empId: '',
    empName: '',
    designation: '',
    institutename: '',
    instituteaddress: '',
    contactperson: '',
    contactpersondesignation: '',
    contactpersonnumber: '',
    contactpersonemail: '',
    followupdate: '',
    comment: '',
    interestshown: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [selectedInterest, setSelectedInterest] = useState('');
  const [employeeRecords, setEmployeeRecords] = useState([]);
  const [showRecords, setShowRecords] = useState(false);
  const [schoolHistoryRecords, setSchoolHistoryRecords] = useState([]);
  const [schoolHistoryLoading, setSchoolHistoryLoading] = useState(false);
  const [schoolHistoryError, setSchoolHistoryError] = useState('');
  const [showShareEmployeeModal, setShowShareEmployeeModal] = useState(false);
  const [shareEmployeeList, setShareEmployeeList] = useState([]);
  const [shareEmployeeLoading, setShareEmployeeLoading] = useState(false);
  const [shareEmployeeError, setShareEmployeeError] = useState('');
  const [shareSourceRecord, setShareSourceRecord] = useState(null);
  const [fromFilter, setFromFilter] = useState("");
  const [toFilter, setToFilter] = useState("");
  const [showRecordDetails, setShowRecordDetails] = useState(false);
  const [selectedInstituteHistory, setSelectedInstituteHistory] = useState([]);
  const [schoolHistoryPopupLoading, setSchoolHistoryPopupLoading] = useState(false);
  const [popupContactPerson, setPopupContactPerson] = useState('');
  const [popupContactDesignation, setPopupContactDesignation] = useState('');
  const [popupContactNumber, setPopupContactNumber] = useState('');
  const [popupContactEmail, setPopupContactEmail] = useState('');
  const [popupInstituteAddress, setPopupInstituteAddress] = useState('');




  const expandMouRows = (records) => {
    const expanded = [];

    records.forEach((record) => {
      expanded.push({
        ...record,
        rowType: record.rowType || 'base',
      });

      if (record.mouSubmittedDate && record.mouSubmittedDate !== '-') {
        expanded.push({
          ...record,
          rowType: 'mou-submitted',
          comment: 'MOU Submitted',
          followupdate: record.mouSubmittedDate,
          lastfollowupdate: record.mouSubmittedDate,
        });
      }

      if (record.mouPaidDate && record.mouPaidDate !== '-') {
        expanded.push({
          ...record,
          rowType: 'payment-received',
          comment: 'Payment Received',
          followupdate: record.mouPaidDate,
          lastfollowupdate: record.mouPaidDate,
        });
      }
    });

    return expanded;
  };

  const formatDisplayDate = (dateValue) => {
    if (!dateValue || dateValue === '-') return '-';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return '-';
    }

    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const fetchSchoolHistory = async (empId) => {
    if (!empId) return;

    try {
      console.log('[SalesPerformance] fetching school history for empId:', empId);
      setSchoolHistoryLoading(true);
      setSchoolHistoryError('');

      const response = await axios.get(
        `https://cleezoclass.com:8443/api/sales-performance-schools/${empId}`
      );

      console.log('[SalesPerformance] school history response:', response.data);
      setSchoolHistoryRecords(expandMouRows(Array.isArray(response.data) ? response.data : []));
    } catch (error) {
      console.error('[SalesPerformance] error fetching school history:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url,
      });
      try {
        console.log('[SalesPerformance] falling back to sales-performance-table for empId:', empId);
        const fallbackResponse = await axios.get(
          `https://cleezoclass.com:8443/api/sales-performance-table/${empId}`
        );

        const fallbackRecords = Array.isArray(fallbackResponse.data)
          ? fallbackResponse.data.map((record) => ({
            empName: formData.empName,
            institutename: record.institutename || '-',
            instituteaddress: record.instituteaddress || '-',
            contactperson: record.contactperson || '-',
            contactpersondesignation: record.contactpersondesignation || '-',
            contactpersonnumber: record.contactpersonnumber || '-',
            startdate: record.created_at || record.followupdate || null,
            followupdate: record.followupdate || '-',
            lastfollowupdate: record.created_at || record.followupdate || null,
            mouStatus: record.mouStatus || 'Not Submitted',
            mouSubmittedDate: record.mouSubmittedDate || '-',
            mouPaidDate: record.mouPaidDate || '-',
            comment: record.comment || '-',
          }))
          : [];

        console.log('[SalesPerformance] fallback school history response:', fallbackRecords);
        setSchoolHistoryRecords(expandMouRows(fallbackRecords));
        setSchoolHistoryError('');
      } catch (fallbackError) {
        console.error('[SalesPerformance] fallback school history error:', {
          message: fallbackError.message,
          status: fallbackError.response?.status,
          data: fallbackError.response?.data,
          url: fallbackError.config?.url,
        });
        setSchoolHistoryError(
          error.response?.data?.error || 'Unable to fetch school history'
        );
        setSchoolHistoryRecords([]);
      }
    } finally {
      setSchoolHistoryLoading(false);
    }
  };

  const openShareEmployeeModal = async (record) => {
    try {
      setShareSourceRecord(record);
      setShareEmployeeLoading(true);
      setShareEmployeeError('');

      const response = await axios.get(
        'https://cleezoclass.com:8443/api/employee-names'
      );

      console.log('[SalesPerformance] employees loaded for share:', response.data);
      setShareEmployeeList(Array.isArray(response.data) ? response.data : []);
      setShowShareEmployeeModal(true);
    } catch (error) {
      console.error('[SalesPerformance] error loading employee names:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url,
      });
      setShareEmployeeError('Unable to load employees.');
      setShowShareEmployeeModal(true);
    } finally {
      setShareEmployeeLoading(false);
    }
  };

  const shareRecordToEmployee = async (selectedEmployee) => {
    if (!shareSourceRecord || !selectedEmployee?.empId) return;

    try {
      const response = await axios.post(
        'https://cleezoclass.com:8443/api/share-school-history',
        {
          empId: selectedEmployee.empId,
          empName: selectedEmployee.empName,
          designation: selectedEmployee.designation || formData.designation,
          sharedByEmpId: formData.empId,
          sharedByEmpName: formData.empName,
          sharedByDesignation: formData.designation,
          institutename: shareSourceRecord.institutename,
          instituteaddress: shareSourceRecord.instituteaddress || '',
          contactperson: shareSourceRecord.contactperson || '',
          contactpersondesignation: shareSourceRecord.contactpersondesignation || '',
          contactpersonnumber: shareSourceRecord.contactpersonnumber || '',
          contactpersonemail: shareSourceRecord.contactpersonemail || '',
          interestshown: shareSourceRecord.interestshown || 'Follow Up',
          comment: `Shared to ${selectedEmployee.empName} by ${formData.empName}`,
        }
      );

      console.log('[SalesPerformance] share response:', response.data);
      if (response.status === 200) {
        setSuccessMessage(`Shared with ${selectedEmployee.empName} successfully.`);
        localStorage.setItem('salesPerformanceRefreshAt', Date.now().toString());
        window.dispatchEvent(new Event('salesPerformanceRefresh'));
        setShowShareEmployeeModal(false);
        setShareSourceRecord(null);
        setTimeout(() => setSuccessMessage(''), 5000);
      }
    } catch (error) {
      console.error('Error sharing school history:', error);
      setErrorMessage('Unable to share school history.');
    }
  };

  const handleClick = (interest, color) => {
    setFormData({ ...formData, interestshown: interest });
    setSelectedInterest(color);
  };

  // Inside your component, alongside handleMailClick
  const handleWhatsappClick = () => {
    const phone = formData.contactpersonnumber; // make sure it's in international format
    const message = `Hello ${formData.contactperson}, this is ${formData.empName} from ${formData.institutename}.`;
    const whatsappURL = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, 'whatsappWindow');

  };

  // Handle mail icon click
  const handleMailClick = async () => {
    try {
      const email = formData.contactpersonemail;

      // Debugging: Check email
      console.log("Email to be sent: ", email);

      if (!email) {
        console.error("No email provided in the form data");
        setErrorMessage('No email provided!'); // Update UI with error
        return;  // Stop if no email
      }

      // Send the POST request to backend
      const response = await axios.post(
        'https://cleezoclass.com:8443/api/send-email',
        {
          email: formData.contactpersonemail,
          contactperson: formData.contactperson,
          institutename: formData.institutename,
          empName: formData.empName,
        }
      );


      // Check if the email was sent successfully
      if (response.status === 200) {
        setSuccessMessage('Email sent successfully!');
      } else {
        setErrorMessage('Failed to send email!');
      }
    } catch (error) {
      console.error('Error sending email:', error.response ? error.response.data : error.message);
      // Update the UI with error message
      setErrorMessage('Error sending email.');
    }
  };


  const handleViewMyData = async () => {
    try {
      const response = await axios.get(
        `https://cleezoclass.com:8443/api/sales-performance-table/${formData.empId}`

      );

      setEmployeeRecords(response.data);
      setShowRecords(true);
    } catch (error) {
      console.error('Error fetching employee data:', error);
      setErrorMessage('Unable to fetch your records');
    }
  };


  // Fetch employee details from localStorage
  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (storedEmpId && storedEmpName && storedDesignation) {
      setFormData((prevData) => ({
        ...prevData,
        empId: storedEmpId,
        empName: storedEmpName,
        designation: storedDesignation,
      }));
    } else {
      alert('Session expired or employee details not found. Please log in again.');
      window.location.href = '/login';
    }
  }, []);

  useEffect(() => {
    fetchSchoolHistory(formData.empId);
  }, [formData.empId]);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === 'salesPerformanceRefreshAt' && formData.empId) {
        fetchSchoolHistory(formData.empId);
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [formData.empId]);

  useEffect(() => {
    const handleRefresh = () => {
      if (formData.empId) {
        fetchSchoolHistory(formData.empId);
      }
    };

    window.addEventListener('salesPerformanceRefresh', handleRefresh);
    return () => window.removeEventListener('salesPerformanceRefresh', handleRefresh);
  }, [formData.empId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const normalizeContactNumber = (value) =>
    String(value || '').trim().replace(/\D/g, '');

  const getDuplicateOwnerLabel = (record) => {
    const ownerName = String(record?.empName || record?.employeeName || '').trim();
    const ownerId = String(record?.empId || record?.employeeId || '').trim();

    if (ownerName && ownerId) {
      return `${ownerName} (${ownerId})`;
    }

    return ownerName || ownerId || 'another employee';
  };

  const handleNotificationInstituteClick = (item) => {
    if (!item) return;
    openSchoolHistoryPopup(item);
  };

  const handleOpenRecordDetails = async (record) => {
    setShowRecordDetails(true);
    setSchoolHistoryPopupLoading(true);

    try {
      const instituteName = record?.institutename?.trim();

      if (!instituteName) {
        throw new Error('Institute name is missing.');
      }

      const [historyResponse, detailsResponse] = await Promise.all([
        axios.get(
          `https://cleezoclass.com:8443/api/school-history/${encodeURIComponent(instituteName)}`
        ),
        axios.get(
          `https://cleezoclass.com:8443/api/sales-performance/${encodeURIComponent(instituteName)}`
        ),
      ]);

      const normalizedHistory = Array.isArray(historyResponse.data)
        ? historyResponse.data
            .map((item) => ({
              ...item,
              date: item.date || item.followupdate || item.startdate || item.lastfollowupdate || null,
              comment: item.comment || '-',
              interestshown: item.interestshown || '-',
            }))
            .sort(
              (a, b) =>
                new Date(b.date || b.updated_at || 0) - new Date(a.date || a.updated_at || 0)
            )
        : [];

      const fallbackHistory = [
        {
          date:
            record.date ||
            record.startdate ||
            record.followupdate ||
            record.lastfollowupdate ||
            new Date().toISOString(),
          institutename: record.institutename,
          comment: record.comment || '-',
          interestshown: record.interestshown || '-',
        },
      ];

      setSelectedInstituteHistory(normalizedHistory.length > 0 ? normalizedHistory : fallbackHistory);
      setShareSourceRecord({
        ...record,
        originalStartDate:
          record.startdate || record.date || record.followupdate || record.lastfollowupdate || null,
      });

      setPopupContactPerson(detailsResponse.data.contactperson || '-');
      setPopupContactDesignation(detailsResponse.data.contactpersondesignation || '-');
      setPopupContactNumber(detailsResponse.data.contactpersonnumber || '-');
      setPopupContactEmail(detailsResponse.data.contactpersonemail || '');
      setPopupInstituteAddress(detailsResponse.data.instituteaddress || '-');
    } catch (error) {
      console.error('Error fetching popup contact details:', error);
      setSelectedInstituteHistory([
        {
          date:
            record?.date ||
            record?.startdate ||
            record?.followupdate ||
            record?.lastfollowupdate ||
            new Date().toISOString(),
          institutename: record?.institutename || '-',
          comment: record?.comment || '-',
          interestshown: record?.interestshown || '-',
        },
      ]);
      setPopupContactPerson('-');
      setPopupContactDesignation('-');
      setPopupContactNumber('-');
      setPopupContactEmail('');
      setPopupInstituteAddress('-');
    } finally {
      setSchoolHistoryPopupLoading(false);
    }
  };

  const openSchoolHistoryPopup = async (record) => {
    await handleOpenRecordDetails(record);
  };

  const handleDemoClick = () => {
    window.open('https://cleezoclass.com/book-demo', '_blank', 'noopener,noreferrer');
  };

  const handleMouClick = () => {
    navigate('/MOUProcess');
  };

  const handleCentralisationClick = () => {
    navigate('/Centralisation');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submit triggered');

    // Ensure required fields are filled
    if (
      !formData.institutename ||
      !formData.instituteaddress ||
      !formData.contactperson ||
      !formData.contactpersondesignation ||
      !formData.followupdate ||
      !formData.comment ||
      !formData.interestshown
    ) {
      console.warn('Validation failed: Missing required fields');
      setErrorMessage('All fields are required');
      return;
    }

    console.log('Validation passed');

    try {
      const enteredContactNumber = normalizeContactNumber(formData.contactpersonnumber);

      if (enteredContactNumber) {
        const existingResponse = await axios.get(
          'https://cleezoclass.com:8443/api/sales-performance-table'
        );

        const existingRecords = Array.isArray(existingResponse.data)
          ? existingResponse.data
          : [];

        const duplicateRecord = existingRecords.find((record) => {
          const existingContactNumber = normalizeContactNumber(
            record.contactpersonnumber || record.contactNumber || record.contactnumber
          );

          return existingContactNumber && existingContactNumber === enteredContactNumber;
        });

        if (duplicateRecord) {
          const duplicateOwner = getDuplicateOwnerLabel(duplicateRecord);
          const duplicateMessage = `Duplicate record already added for contact number ${formData.contactpersonnumber} by ${duplicateOwner}.`;
          setErrorMessage(duplicateMessage);
          setSuccessMessage('');
          window.alert(duplicateMessage);
          return;
        }
      }

      console.log('Sending POST request to API...');

      const response = await axios.post(
        'https://cleezoclass.com:8443/api/sales-performance-table',
        formData,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      console.log('API response:', response);

      setSuccessMessage('Data saved successfully!');
      setErrorMessage('');

      // Optionally reset form after a delay or user action (not immediately)
      setFormData({
        empId: formData.empId,
        empName: formData.empName,
        designation: formData.designation,
        institutename: '',
        instituteaddress: '',
        contactperson: '',
        contactpersondesignation: '',
        contactpersonnumber: '',
        contactpersonemail: '',
        followupdate: '',
        comment: '',
        interestshown: '',
      });

    } catch (error) {
      console.error('API Error:', error);
      setErrorMessage('Error: Something went wrong.');
      setSuccessMessage('');
    }
  };


  // to filter the data according to dates
  const filteredData = useMemo(() => {
    return schoolHistoryRecords.filter((record) => {
      if (!record.startdate) return false;

      const recordDate = new Date(record.startdate);

      const fromDate = fromFilter ? new Date(fromFilter) : null;
      const toDate = toFilter ? new Date(toFilter) : null;

      if (fromDate && recordDate < fromDate) {
        return false;
      }

      if (toDate) {

        toDate.setHours(23, 59, 59, 999);

        if (recordDate > toDate) {
          return false;
        }
      }

      return true;
    });
  }, [schoolHistoryRecords, fromFilter, toFilter]);


  return (
    <>
      <div className="sales-performance-page-container ">
        <FormNotification onInstituteClick={handleNotificationInstituteClick} />
        <FormAside />
        <h2 className="sales-performance-page-header">Sales Performance Form</h2>
        <form onSubmit={handleSubmit} className="sales-performance-form-container">
          {/* Row 1: Employee Details */}
          <div className="sales-performance-form-row">
            <div className="sales-performance-form-group">
              <label>Employee Name:</label>
              <input type="text" name="empName" value={formData.empName} readOnly />
            </div>
            <div className="sales-performance-form-group">
              <label>Employee ID:</label>
              <input type="text" name="empId" value={formData.empId} readOnly />
            </div>

            <div className="sales-performance-form-group">
              <label>Designation:</label>
              <input type="text" name="designation" value={formData.designation} readOnly />
            </div>
          </div>

          {/* Row 2: Institute Details & Contact Person */}
          <div className="sales-performance-form-row">
            <div className="sales-performance-form-group">
              <label>Institute Name:</label>
              <input type="text" name="institutename" value={formData.institutename} onChange={handleChange} />
            </div>
            <div className="sales-performance-form-group">
              <label>Institute Address:</label>
              <input type="text" name="instituteaddress" value={formData.instituteaddress} onChange={handleChange} />
            </div>
            <div className="sales-performance-form-group">
              <label>Contact Person Number:</label>
              <input type="text" name="contactpersonnumber" value={formData.contactpersonnumber} onChange={handleChange} />
            </div>
          </div>

          {/* Row: Contact Person Details */}
          <div className="sales-performance-form-row">
            <div className="sales-performance-form-group">
              <label>Contact Person Name:</label>
              <input
                type="text"
                name="contactperson"
                value={formData.contactperson}
                onChange={handleChange}
              />
            </div>
            <div className="sales-performance-form-group">
              <label>Contact Person Designation:</label>
              <input
                type="text"
                name="contactpersondesignation"
                value={formData.contactpersondesignation}
                onChange={handleChange}
              />
            </div>
            <div className="sales-performance-form-group">
              <label>Contact Person Email:</label>
              <input
                type="email"
                name="contactpersonemail"
                value={formData.contactpersonemail}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Row 4: Follow-Up Date, Comment, Interest Shown, Actions */}
          <div className="sales-performance-form-row sales-performance-actions-row">
            <div className="sales-performance-form-group">
              <label>Follow-Up Date:</label>
              <input
                type="date"
                name="followupdate"
                value={formData.followupdate}
                onChange={handleChange}
              />
            </div>
            <div className="sales-performance-form-group">
              <label>Comment:</label>
              <textarea name="comment" value={formData.comment} onChange={handleChange}></textarea>
            </div>
            <div className="sales-performance-form-group">
              <label>Interest Shown:</label>
              <div className="sales-performance-interest-circles">
                <div
                  className={`sales-performance-interest-circle ${selectedInterest === 'red' ? 'selected' : ''}`}
                  style={{ backgroundColor: 'red' }}
                  onClick={() => handleClick('Not Interested', 'red')}
                  title="Not Interested"
                ></div>
                <div
                  className={`sales-performance-interest-circle ${selectedInterest === 'yellow' ? 'selected' : ''}`}
                  style={{ backgroundColor: 'yellow' }}
                  onClick={() => handleClick('Follow Up', 'yellow')}
                  title="Follow Up"
                ></div>
                <div
                  className={`sales-performance-interest-circle ${selectedInterest === 'green' ? 'selected' : ''}`}
                  style={{ backgroundColor: 'green' }}
                  onClick={() => handleClick('Interested', 'green')}
                  title="Interested"
                ></div>
              </div>
            </div>

          </div>
          <div className="sales-performance-form-group sales-performance-action-group">
            <div className="action-buttons">
              <button type="submit">Submit</button>
              <button type="button" onClick={handleViewMyData}>
                My Leads              </button>
            </div>

            {(errorMessage || successMessage) && (
              <div className="sales-performance-status-message">
                {errorMessage && <p className="sales-performance-error-message">{errorMessage}</p>}
                {successMessage && <p className="sales-performance-success-message">{successMessage}</p>}
              </div>
            )}

            <div className='sales-performance-form-dates-group'>
              <div className="sales-performance-form-group">
                <label>From Date:</label>
                <input
                  type="date"
                  value={fromFilter}
                  onChange={(e) => setFromFilter(e.target.value)}
                />
              </div>
              <div className="sales-performance-form-group">
                <label>To Date:</label>
                <input
                  type="date"
                  value={toFilter}
                  onChange={(e) => setToFilter(e.target.value)}
                />
              </div>


            </div>

            {successMessage && (
              <div className="action-icons">
                <div className="icon-card mail" onClick={handleMailClick}>
                  <FaEnvelope />
                  <span>Email</span>
                </div>

                <div className="icon-card whatsapp" onClick={handleWhatsappClick}>
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </div>
              </div>
            )}
          </div>
          {/* Submit Button Row */}
          {/* <div className="action-row">
  <div className="action-buttons">
    <button type="submit" >
      Submit
    </button>

    <button
      type="button"
      onClick={handleViewMyData}
    >
      View Data
    </button>
  </div>

  {successMessage && (
    <div className="action-icons">
      <div className="icon-card mail" onClick={handleMailClick}>
        <FaEnvelope />
        <span>Email</span>
      </div>

      <div className="icon-card whatsapp" onClick={handleWhatsappClick}>
        <FaWhatsapp />
        <span>WhatsApp</span>
      </div>
    </div>
  )}
</div> */}


          <div className="sales-school-history-card">

            {!formData.empId ? (
              <p>Loading employee details...</p>
            ) : schoolHistoryLoading ? (
              <p>Loading school history...</p>
            ) : schoolHistoryError ? (
              <p className="sales-performance-error-message" style={{ marginTop: 0 }}>
                {schoolHistoryError}
              </p>
            ) : schoolHistoryRecords.length > 0 ? (
              <div className="sales-school-history-table-wrapper">
                <table className="sales-performance-table">
                  <thead>
                    <tr>
                      <th>Employee Name</th>
                      <th>Institute Name</th>
                      <th>Address</th>
                      <th>Contact Name</th>
                      <th>Contact Designation</th>
                      <th>Contact Number</th>
                      <th>Start Date</th>
                      <th>Follow-Up Date</th>
                      <th>Newest on Top</th>
                      <th >Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* At first all data will display after filter only filtered Data should display */}
                    {filteredData.map((record, index) => (
                      (() => {
                        const rowColor =
                          record.rowType === 'mou-submitted'
                            ? '#047857'
                            : record.rowType === 'payment-received'
                              ? '#1d4ed8'
                              : 'inherit';

                        return (
                          <tr
                            key={`${record.institutename}-${index}`}
                            style={{ color: rowColor }}
                          >
                            <td style={{ color: rowColor }}>{record.empName || '-'}</td>
                            <td style={{ color: rowColor }}>{record.institutename || '-'}</td>
                            <td style={{ color: rowColor }}>{record.instituteaddress || '-'}</td>
                            <td style={{ color: rowColor }}>{record.contactperson || '-'}</td>
                            <td style={{ color: rowColor }}>{record.contactpersondesignation || '-'}</td>
                            <td style={{ color: rowColor }}>{record.contactpersonnumber || '-'}</td>
                            <td style={{ color: rowColor }}>{formatDisplayDate(record.startdate)}</td>
                            <td style={{ color: rowColor }}>{formatDisplayDate(record.followupdate)}</td>
                            <td style={{ color: rowColor }}>{formatDisplayDate(record.lastfollowupdate)}</td>
                            <td
                              style={{
                                color: record.comment?.includes('Shared to') ? 'green' : 'inherit',
                                fontWeight: record.comment?.includes('Shared to') ? '600' : 'normal',
                              }}
                            >{record.comment || '-'}</td>
                          </tr>
                        );
                      })()
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No schools found for this employee.</p>
            )}
          </div>
        </form>
        {showRecords && (
          <div className="sales-modal-overlay" onClick={() => setShowRecords(false)}>
            <div
              className="sales-modal-content"
              onClick={(e) => e.stopPropagation()} // prevent close on inside click
            >
              <h3>My Submitted Records</h3>

              {employeeRecords.length > 0 ? (
                <table className="sales-performance-table">
                  <thead>
                    <tr>
                      <th>Institute</th>
                      <th>Contact Person</th>
                      <th>Date</th>
                      <th>Interest</th>
                      <th>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeRecords.map((record, index) => (
                      <tr key={index}>
                        <td>{record.institutename}</td>
                        <td>{record.contactperson}</td>
                        <td>
                          {new Date(record.followupdate).toLocaleDateString('en-GB', {
                            day: '2-digit', month: 'short', year: 'numeric'
                          })}
                        </td>
                        <td>{record.interestshown}</td>
                        <td>{record.comment}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No records found</p>
              )}
            </div>
          </div>
        )}



        {/* Show success icon and message after form submission */}
        {showRecordDetails && (
          <div className="sales-modal-overlay" onClick={() => setShowRecordDetails(false)}>
            <div
              className="sales-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sales-history-top-row">
                <div className="sales-history-contact">
                  <div className="sales-history-contact-name">{popupContactPerson || '-'}</div>
                  <div className="sales-history-contact-number">{popupContactNumber || '-'}</div>
                </div>
                <div className="sales-history-title-wrap">
                  <h3 className="sales-history-title">
                    History - {selectedInstituteHistory?.[0]?.institutename || shareSourceRecord?.institutename || '-'}
                  </h3>
                  <div className="sales-history-address">{popupInstituteAddress || '-'}</div>
                </div>
                <div className="sales-history-comments">
                  <div className="sales-history-comments-title">Last Comments</div>
                  <ul className="sales-history-comments-list">
                    {selectedInstituteHistory.slice(0, 3).map((item, index) => (
                      <li key={`comment-${index}`}>
                        {item.comment || '-'}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {schoolHistoryPopupLoading ? (
                <p className="sales-history-loading">Loading school history...</p>
              ) : (
                <table className="sales-performance-table sales-history-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Comment</th>
                      <th>Interest</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedInstituteHistory.length > 0 ? (
                      selectedInstituteHistory.map((item, index) => (
                        <tr key={`${item.institutename || 'record'}-${index}`}>
                          <td>{formatDisplayDate(item.date)}</td>
                          <td>{item.comment || '-'}</td>
                          <td>{item.interestshown || '-'}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3">No history found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}

              <div className="sales-history-actions">
                <button type="button" onClick={() => setShowRecordDetails(false)}>Close</button>
                <button type="button" onClick={() => openShareEmployeeModal(shareSourceRecord || selectedInstituteHistory[0])}>
                  Share FollowUp
                </button>
                <button type="button" onClick={handleDemoClick}>Demo</button>
                <button type="button" onClick={handleMouClick}>MOU</button>
                <button type="button" onClick={handleCentralisationClick}>Centralisation</button>
              </div>
            </div>
          </div>
        )}

        {showShareEmployeeModal && (
          <div className="sales-modal-overlay" onClick={() => setShowShareEmployeeModal(false)}>
            <div
              className="sales-modal-content"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: '700px' }}
            >
              <h3>Select Employee to Share With</h3>
              <p style={{ marginTop: 0, color: '#64748b' }}>
                Sharing: {shareSourceRecord?.institutename || '-'}
              </p>

              {shareEmployeeLoading ? (
                <p>Loading employees...</p>
              ) : shareEmployeeError ? (
                <p className="sales-performance-error-message">{shareEmployeeError}</p>
              ) : (
                <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                  {shareEmployeeList.length > 0 ? (
                    shareEmployeeList.map((employee) => (
                      <button
                        key={employee.empId || employee.empName}
                        type="button"
                        onClick={() => shareRecordToEmployee(employee)}
                        style={{
                          display: 'block',
                          width: '100%',
                          textAlign: 'left',
                          marginBottom: '8px',
                          padding: '10px 12px',
                          border: '1px solid #ddd',
                          borderRadius: '8px',
                          background: '#fff',
                          cursor: 'pointer',
                          color: '#000'
                        }}
                      >
                        {employee.empName}
                        {employee.empId ? ` (${employee.empId})` : ''}
                        {employee.designation ? ` - ${employee.designation}` : ''}
                      </button>
                    ))
                  ) : (
                    <p>No employees found.</p>
                  )}
                </div>
              )}

              <button
                type="button"
                onClick={() => setShowShareEmployeeModal(false)}
                className="sales-performance-button secondary"
                style={{ marginTop: '14px' }}
              >
                Close
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default SalesPerformance;
